<template>
  <div>
    <el-form ref="searchForm" :model="searchForm" class="searchBoxLine" inline>
      <el-form-item label="申请发货单号:" prop="deliveryNum">
        <el-input v-model.trim="searchForm.deliveryNum" placeholder="请输入申请发货单号码" />
      </el-form-item>
      <el-form-item label="合同编号:" prop="contractNum">
        <el-input v-model.trim="searchForm.contractNum" placeholder="请输入合同编号" />
      </el-form-item>
      <el-form-item label="项目名称:" prop="projectName">
        <el-input v-model.trim="searchForm.projectName" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="状态:" prop="processState">
        <el-select v-model="searchForm.processState" clearable>
          <el-option
            v-for="item in processStateSelectList"
            :key="item.dictLabel"
            :label="item.dictValue"
            :value="item.dictLabel"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="申请时间:" prop="endTime">
        <el-date-picker
          v-model="searchForm.startTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          @change="handleStartTimeChange"
        />
        <div style="display: inline-block;width: 10px;text-align: center">
          -
        </div>
        <el-date-picker
          v-model="searchForm.endTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        />
      </el-form-item>
      <el-form-item label="是否需要唛头:" prop="markType">
        <el-select v-model="searchForm.markType" clearable>
          <el-option label="全部" value="" />
          <el-option label="是" :value="1" />
          <el-option label="否" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">
          查询
        </el-button>
        <el-button type="default" @click="clearSearchForm">
          重置
        </el-button>
        <!-- <el-button type="default" :loading="isCreatePiLoading" @click="createPI()">
          生成PI
        </el-button> -->
      </el-form-item>
    </el-form>
    <div>
      <div class="operate-btn-wrap">
        <!-- <el-button type="primary" :loading="isCreatePiLoading" @click="exportShipmentReport()">
          导出发货单报表
        </el-button> -->
      </div>
      <el-table v-loading="tableLoading" :data="tableData" border @selection-change="handleSelectionChange">
        <el-table-column align="left" type="selection" label="操作" />
        <el-table-column prop="deliveryNum" label="申请发货单号" align="left" width="150">
          <template v-slot="{row}">
            <el-button style="user-select: all;" type="text" @click="lookOrEditApplyForDelivery(row,'detail')">
              {{ row.deliveryNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="合同编号" prop="contractNum" align="left" width="150">
          <template v-slot="{row}">
            <el-button style="user-select: all;" type="text" @click="lookContract(row)">
              {{ row.contractNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="项目名称" prop="projectName" align="left" width="300" />
        <el-table-column label="收货地址" prop="receiptAddress" align="left" width="300" />
        <el-table-column label="发货金额" prop="partialInvoiceAmount" align="right" header-align="left" width="100">
          <template v-slot="{row}">
            {{ row.partialInvoiceAmount && Number(row.partialInvoiceAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="币种" prop="currencyName" align="left" width="100" />
        <el-table-column label="申请日期" prop="createTime" align="left" width="100">
          <template v-slot="{row}">
            {{ row.createTime && DateToStr(new Date(row.createTime)) }}
          </template>
        </el-table-column>
        <el-table-column label="状态信息" prop="processStateStr" align="left" width="100" />
        <el-table-column label="是否需要唛头" prop="markType" align="left" width="100">
          <template v-slot="{row}">
            {{ row.markType === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="发货单号" prop="invoiceNum" align="left" width="150">
          <template v-slot="{row}">
            <el-button style="user-select: all;" type="text" @click="lookShippingList(row)">
              {{ row.invoiceNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="物流单号" prop="logisticsNum" align="left" width="150">
          <template v-slot="{row}">
            <el-button type="text" @click="lookLogistics(row)">
              {{ row.logisticsNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="physicalFlag"
          label="是否含非实物"
          align="left"
          width="100"
        >
          <template v-slot="{row}">
            {{ row.physicalFlag ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="batteryFlag"
          label="是否带电池"
          align="left"
          width="100"
        >
          <template v-slot="{row}">
            {{ row.batteryFlag ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="left" width="200">
          <template v-slot="{row}">
            <template v-if="!row.isDelete">
              <!-- <el-button type="text" @click="createPI(row)">
                生成PI
              </el-button> -->
              <el-button v-if="row.recall" type="text" @click="recallApplied(row)">
                召回
              </el-button>
              <el-button v-if="row.edit" type="text" @click="lookOrEditApplyForDelivery(row,'edit')">
                编辑
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :page-sizes="[10, 20, 30, 40]"
        :page-size.sync="pageState.pageSize"
        :current-page.sync="pageState.pageIndex"
        layout="->,total, prev, pager, next, jumper,sizes"
        :total="pageState.total"
        style="margin-top: 10px"
        @size-change="handlerSizeChange"
        @current-change="handlerCurrentChange"
      />

      <InternationalShippingListDialog
        :current-click-data="currentClickData"
        :dialog-visible-from-shipping-list="dialogVisibleFromShippingList"
        @on-status-dialog="updateDialogVisibleFromShippingList"
      />

      <InternationalLogisticsInformationDialog
        :current-click-data="currentClickData"
        :dialog-visible-from-logistics="dialogVisibleFromLogistics"
        @on-status-dialog="updateDialogVisibleFromLogistics"
      />

      <InternationalRecallDialog
        :current-click-data="currentClickData"
        :dialog-visible-form-recall="dialogVisibleFromRecall"
        @on-status-dialog="updateDialogVisibleFromRecall"
        @refresh-table="getData"
      />

      <InternationalApplyForDeliveryDialog
        :is-detail="isApplyForDeliveryDialogDetail"
        :is-edit="isApplyForDeliveryDialogEdit"
        :show-notes="1"
        is-distri-money
        :current-click-data="currentClickData"
        :dialog-visible-from-apply-for-delivery="dialogVisibleFromApplyForDelivery"
        @on-status-dialog="updateDialogVisibleFromApplyForDelivery"
        @refresh-table="handleSearch"
      />
    </div>
  </div>
</template>

<script>
import { exportPi, getRequestedAnInvoice, getExportPartialInvoice } from '@/API/international';
import InternationalShippingListDialog from '@/views/business/components/InternationalShippingListDialog.vue';
import InternationalLogisticsInformationDialog from '@/views/business/components/InternationalLogisticsInformationDialog.vue';
import InternationalRecallDialog from '@/views/business/components/InternationalRecallDialog.vue';
import InternationalApplyForDeliveryDialog from '@/views/business/components/InternationalApplyForDeliveryDialog.vue';
import { Message, Notification } from 'element-ui';
import { getDictData } from '@/API';
import { DateToStr, downloadBlobFile } from '@/libs/util';
import { mapState } from 'vuex';

/**
 * 国际已申请发货单列表
 */
export default {
  name: 'InternationalInvoiceHasBeenApplied',
  components: {
    InternationalApplyForDeliveryDialog,
    InternationalRecallDialog,
    InternationalLogisticsInformationDialog,
    InternationalShippingListDialog
  },
  data () {
    return {
      searchForm: {
        deliveryNum: undefined, // 申请发货单号码
        contractNum: undefined,
        projectName: undefined,
        processState: undefined,
        markType: undefined,
        endTime: undefined,
        startTime: undefined
      },
      pageState: {
        pageIndex: 1,
        total: 10,
        pageSize: 10
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.startTime) {
            let date = new Date(this.searchForm.startTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      processStateSelectList: [],
      tableLoading: false,
      tableData: [],
      dialogVisibleFromShippingList: false,
      dialogVisibleFromLogistics: false,
      dialogVisibleFromApplyForDelivery: false,
      dialogVisibleFromRecall: false,
      isApplyForDeliveryDialogEdit: true,
      isApplyForDeliveryDialogDetail: false,
      currentClickData: {},
      selectRows: [],
      isCreatePiLoading: false
    };
  },
  computed: {
    ...mapState('pagesTemporary', ['OrderPersionContractListTabActive']),
    tabsActive () {
      return this.$store.state.pagesTemporary.OrderPersionInterContractListTabActive;
    }
  },
  watch: {
    /**
     * 详情或者编辑应相反
     */
    isApplyForDeliveryDialogEdit (value) {
      this.isApplyForDeliveryDialogDetail = !value;
    },
    isApplyForDeliveryDialogDetail (value) {
      this.isApplyForDeliveryDialogEdit = !value;
    },
    OrderPersionContractListTabActive () {
      this.OrderPersionContractListTabActive === '6' && this.clearSearchForm();
    },
    tabsActive () {
      this.tabsActive === '3' && this.clearSearchForm();
    }
  },
  methods: {
    DateToStr,
    /**
     * 清空搜索框 重置分页器
     */
    clearSearchForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.startTime = undefined;
      this.pageState.pageIndex = 1;
      this.pageState.pageSize = 10;
      this.getData();
    },
    /**
     * 搜索事件保留页面大小参数
     */
    handleSearch () {
      this.pageState.pageIndex = 1;
      this.getData();
    },
    /**
     * 当勾选时 把勾选数据存起来
     */
    handleSelectionChange (rows) {
      this.selectRows = rows;
    },
    getData () {
      this.tableLoading = true;
      let params = {
        pageIndex: this.pageState.pageIndex,
        pageSize: this.pageState.pageSize
      };
      for (let searchFormKey in this.searchForm) {
        (this.searchForm[searchFormKey] || this.searchForm[searchFormKey] === 0) && (params[searchFormKey] = this.searchForm[searchFormKey]);
      }
      let haveStartTime = !!this.searchForm.startTime;
      let haveEndTime = !!this.searchForm.endTime;
      let timeParams = {};
      if (haveStartTime && haveEndTime) {
        timeParams = {
          startTime: `${this.searchForm.startTime} 00:00:00`,
          endTime: `${this.searchForm.endTime} 23:59:59`
        };
      } else if (haveStartTime || haveEndTime) {
        if (haveStartTime) {
          timeParams = {
            startTime: `${this.searchForm.startTime} 00:00:00`
          };
        } else {
          timeParams = {
            endTime: `${this.searchForm.endTime} 23:59:59`
          };
        }
      }
      getRequestedAnInvoice({
        ...params,
        ...timeParams
      }).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          console.log('tableData', this.tableData);
          this.pageState.total = json.data.total;
        } else {
          // 请求失败清空数据
          this.tableData = [];
        }
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    handlerSizeChange (value) {
      this.pageState.pageIndex = 1;
      this.pageState.pageSize = value;
      this.getData();
    },
    handlerCurrentChange (value) {
      this.pageState.pageIndex = value;
      this.getData();
    },
    /**
     * 这里传入弹窗的数据是合同号码 还是 整条数据
     * @param row
     */
    lookOrEditApplyForDelivery (row, type) {
      type === 'detail' && (this.isApplyForDeliveryDialogDetail = true);
      type === 'edit' && (this.isApplyForDeliveryDialogEdit = true);
      this.currentClickData = row;
      this.dialogVisibleFromApplyForDelivery = true;
    },
    updateDialogVisibleFromApplyForDelivery (value) {
      this.dialogVisibleFromApplyForDelivery = value;
    },
    /**
     * 合同详情 复用的国内
     * @param row
     */
    lookContract (row) {
      this.$router.push({
        name: 'businessDetails',
        params: { contractNum: row.contractNum },
        query: { distributeFlag: true, type: 3, id: row.contractId, isShowInternationalService: row.civilInternational ? row.civilInternational : '0' }
      });
    },
    /**
     * 发货清单
     * @param row
     */
    lookShippingList (row) {
      // 写死数据
      this.currentClickData = row;
      // this.currentClickData = { contractNum: '101022051000842', invoiceNum: 'FH202206281810' };
      this.dialogVisibleFromShippingList = true;
    },
    updateDialogVisibleFromShippingList (value) {
      this.dialogVisibleFromShippingList = value;
    },
    /**
     * 物流单号详情
     */
    lookLogistics (row) {
      // 写死数据
      this.currentClickData = row;
      // this.currentClickData = { logisticsNum: 'JDVC14714247081', invoiceNum: 'FH202206281844' };
      this.dialogVisibleFromLogistics = true;
    },
    updateDialogVisibleFromLogistics (value) {
      this.dialogVisibleFromLogistics = value;
    },
    /**
     * 召回弹窗
     */
    recallApplied (row) {
      this.currentClickData = row;
      this.dialogVisibleFromRecall = true;
    },
    updateDialogVisibleFromRecall (value) {
      this.dialogVisibleFromRecall = value;
    },
    /**
     * 单个或多个生成PI
     */
    createPI (row) {
      let ids = [];
      if (row) {
        ids.push(row.id);
      } else {
        if (!this.selectRows.length) {
          Message.warning('请至少勾选一条数据');
          return;
        }
        if (this.selectRows.some(item => item.isDelete)) {
          Message.warning('废弃数据不能生成PI');
          return;
        }
        ids = this.selectRows.map(item => item.id);
      }
      this.isCreatePiLoading = true;
      exportPi(ids).then((res) => {
        // console.log(res.headers['content-disposition']);
        if (res.data instanceof Blob) {
          const content = res.data;
          /**
           * 后端有时候会返回一个空白的数据 这个if用于过滤
           * 后端说已解决但是这个还是需要存在防止后端出问题
           */
          // if (content.size === 0) {
          //   this.isCreatePiLoading = false;
          //   return Notification.error('导出PI失败');
          // }
          const blob = new Blob([content]);// 构造一个blob对象来处理数据
          let PIIndex = res.headers['content-disposition'].indexOf('PI');
          const fileName = decodeURI(res.headers['content-disposition'].substring(PIIndex));
          // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
          // IE10以上支持blob但是依然不支持download
          if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
            navigator.msSaveBlob(blob, fileName);
          } else { // 其他浏览器
            const link = document.createElement('a');// 创建a标签
            link.download = fileName;// a标签添加属性
            link.style.display = 'none';
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();// 执行下载
            URL.revokeObjectURL(link.href); // 释放url
            document.body.removeChild(link);// 释放标签
          }
          Notification.success('导出PI成功');
        }
        // 等待拦截器的修改
        // Message.success('生成PI成功');
        this.isCreatePiLoading = false;
      }).catch(() => {
        this.isCreatePiLoading = false;
      });
    },
    // 导出发货单报表
    exportShipmentReport () {
      this.isCreatePiLoading = true;
      let params = {
        pageIndex: this.pageState.pageIndex,
        pageSize: this.pageState.pageSize
      };
      for (let searchFormKey in this.searchForm) {
        (this.searchForm[searchFormKey] || this.searchForm[searchFormKey] === 0) && (params[searchFormKey] = this.searchForm[searchFormKey]);
      }
      let haveStartTime = !!this.searchForm.startTime;
      let haveEndTime = !!this.searchForm.endTime;
      let timeParams = {};
      if (haveStartTime && haveEndTime) {
        timeParams = {
          startTime: `${this.searchForm.startTime} 00:00:00`,
          endTime: `${this.searchForm.endTime} 23:59:59`
        };
      } else if (haveStartTime || haveEndTime) {
        if (haveStartTime) {
          timeParams = {
            startTime: `${this.searchForm.startTime} 00:00:00`
          };
        } else {
          timeParams = {
            endTime: `${this.searchForm.endTime} 23:59:59`
          };
        }
      }
      getExportPartialInvoice({ ...params,
        ...timeParams }).then((res) => {
        if (res.data instanceof Blob) {
          downloadBlobFile({
            content: res.data,
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileName: '发货单报表'
          });
          Notification.success('导出发货单报表成功!');
          this.isCreatePiLoading = false;
        }
      }).catch(() => {
        this.isCreatePiLoading = false;
      });
    },
    handleStartTimeChange (value) {
      let startTime = new Date(value);
      let endTime = new Date(this.searchForm.endTime);
      if (startTime.getTime() > endTime.getTime()) {
        this.searchForm.endTime = undefined;
      }
    },
    getProcessStateSelectList () {
      getDictData(['intel_partial_process_state']).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.processStateSelectList = [{ dictLabel: '', dictValue: '全部' }, ...json.data[0].dictDataVOS];
        }
      });
    }
  },
  mounted () {
    this.getProcessStateSelectList();
    this.getData();
  }
};
</script>

<style scoped>

</style>
